import { render } from "./CustomerLedger.vue?vue&type=template&id=55c9f66c&scoped=true"
import script from "./CustomerLedger.vue?vue&type=script&lang=js"
export * from "./CustomerLedger.vue?vue&type=script&lang=js"

import "./CustomerLedger.vue?vue&type=style&index=0&id=55c9f66c&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c9f66c"]])

export default __exports__